
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="2">
            <v-text-field
              label="Perfil da Turma em Escrita"
              v-model="form.filters.nome"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sca-date-picker
            :cols="2"
            label="Data Início"
            v-model="form.filters.dataInicial"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
          <sca-date-picker
            :cols="2"
            v-model="form.filters.dataFinal"
            label="Data Final"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
          <sca-select-ativo
            :cols="2"
            :config="{
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo',
              label: 'Situação',
            }"
            v-model="form.filters.situacao"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios()"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headers"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        :sort-desc="true"
        show-expand
        :expanded.sync="form.expanded"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="blue-grey lighten-5">
            <v-chip-group active-class="primary--text" column>
              <span class="text-break">{{ item.descricao }}</span>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorio('PDF')"
        @cancel="baixarRelatorio('CSV')"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
import RelatorioLogPerfilTurmaEscritaService from "~/services/relatorios-log/manter-perfil-turma-escrita-log.service";
import DataTableMixin from "~/mixins/datatables.mixin";
import FormatoArquivoEnum from "~/commons/enums/formato-arquivo.enum";

export default {
  name: "RelatorioLogPerfilTurmaEscrita",
  mixins: [
    RelatorioLogPerfilTurmaEscritaService,
    DataTableMixin
  ],
  data: () => ({
    form: {
      filters: {
        nome: null,
        dataInicial: null,
        dataFinal: null,
        situacao: null,
      },
      lists: {
        listRelatorios: [],
      },
      expanded: [],
    },
    expanded: [],
    headers: [
      { text: "Perfil da Turma em Escrita", align: "center", value: "nome" },
      { text: "O que é esperado do aluno", align: "center", value: "data-table-expand" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
      { text: "Ação", align: "center", value: "acao" },
    ]
  }),
  methods: {
    async buscarRelatorios() {
      if (this.validarDatas() && this.verificarFiltrosPreenchidos()) {
        const { data } = await this.$obterRelatorioLogPerfilTurmaEscrita({ params: this.form.filters });
        this.form.lists.listRelatorios = [];
        this.form.expanded = [];
        this.$nextTick(() => {
          this.form.lists.listRelatorios = data.lista;
        });
      }
    },
    validarDatas() {
      const { dataInicial, dataFinal } = this.form.filters;
      if (dataInicial && dataFinal) {
        if (new Date(dataFinal) < new Date(dataInicial)) {
          return this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
        }
      }
      return true;
    },
    verificarFiltrosPreenchidos() {
      const { dataInicial, dataFinal, situacao, nome } = this.form.filters;
      if (situacao == null && !dataInicial && !dataFinal && !nome) {
        return this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
      }
      return true;
    },
    async baixarRelatorio(formato) {
      switch (formato) {
        case FormatoArquivoEnum.CSV:
          return this.baixarRelatorioCSV();
        case FormatoArquivoEnum.PDF:
          return this.baixarRelatorioPDF();
        default:
          return this.$notifyWarning("Formato de relatório inválido.");
      }
    },
    async baixarRelatorioCSV() {
      const { data } = await this.$obterRelatorioLogCSVPerfilTurmaEscrita({ params: this.form.filters });
      this.$baixarRelatorioCSV(data, `SCA.${this.$options.name}${FormatoArquivoEnum.CSV}`, "Operação realizada com sucesso.");
    },
    async baixarRelatorioPDF() {
      const { data } = await this.$obterRelatorioLogPDFPerfilTurmaEscrita({ params: this.form.filters });
      this.$baixarRelatorioPDF(data, `SCA.${this.$options.name}${FormatoArquivoEnum.PDF}`, "Operação realizada com sucesso.");
    },
    resetForm() {
      this.$clearFilters(this.form);
    }
  },
};
</script>
